module.exports = __webpack_public_path__ + "media/images/dy_code-c863a25ff9f1ee68cf0f08cb058cbd73.png";